// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TerminationStatus from "../../../../app/termination/entity/TerminationStatus.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";

function DriverTerminationListTable$LinkRenderer(Props) {
  var value = Props.value;
  return React.createElement("a", {
              href: value,
              target: "_blank"
            }, "PenaltyList");
}

var LinkRenderer = {
  make: DriverTerminationListTable$LinkRenderer
};

function getTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "From"
            },
            accessor: (function (record) {
                return {
                        TAG: /* Text */0,
                        _0: record.startTime
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "To"
              },
              accessor: (function (record) {
                  return {
                          TAG: /* Text */0,
                          _0: record.endTime
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Duration"
                },
                accessor: (function (record) {
                    return {
                            TAG: /* Text */0,
                            _0: record.duration
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Reason"
                  },
                  accessor: (function (record) {
                      return {
                              TAG: /* Text */0,
                              _0: OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(record.description)
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Status"
                    },
                    accessor: (function (record) {
                        return {
                                TAG: /* Text */0,
                                _0: TerminationStatus.toString(record.status)
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Terminated By"
                      },
                      accessor: (function (record) {
                          return {
                                  TAG: /* Text */0,
                                  _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(record.admin)
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Comment"
                        },
                        accessor: (function (record) {
                            return {
                                    TAG: /* Text */0,
                                    _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(record.comment)
                                  };
                          })
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        };
}

function DriverTerminationListTable(Props) {
  var tableData = Props.tableData;
  return React.createElement("div", {
              className: "table-wrapper"
            }, React.createElement(TableComponent$Catalyst.make, {
                  columns: getTableColumnsSchema(undefined),
                  rowData: tableData,
                  className: "customTable"
                }));
}

var make = DriverTerminationListTable;

export {
  LinkRenderer ,
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
